var _rect, _rect2, _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_3197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_3197)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 14.6666C16.577 14.6666 18.6663 12.5773 18.6663 9.99998C18.6663 7.42265 16.577 5.33331 13.9997 5.33331C11.4223 5.33331 9.33301 7.42265 9.33301 9.99998C9.33301 12.5773 11.4223 14.6666 13.9997 14.6666Z",
    fill: "#E01B41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1686_3197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 14.6666C16.577 14.6666 18.6663 12.5773 18.6663 9.99998C18.6663 7.42265 16.577 5.33331 13.9997 5.33331C11.4223 5.33331 9.33301 7.42265 9.33301 9.99998C9.33301 12.5773 11.4223 14.6666 13.9997 14.6666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1686_3197)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33283 10.6666C10.6662 11.9166 12.6662 12.6666 13.9995 10.6666C15.3328 8.66663 17.9995 8.66663 18.6662 10.6666C19.3328 12.6666 18.6662 14.6666 18.6662 14.6666H9.33283C9.33283 14.6666 7.99949 9.41663 9.33283 10.6666Z",
    fill: "#0E4B9C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17329 3.55661C6.26534 3.39718 6.46921 3.34256 6.62864 3.43461L7.20599 3.76794C7.36542 3.85999 7.42004 4.06385 7.328 4.22328L5.66133 7.11003C5.56928 7.26946 5.36542 7.32409 5.20599 7.23204L4.62864 6.89871C4.46921 6.80666 4.41458 6.6028 4.50663 6.44337L6.17329 3.55661ZM20.7944 3.76794C20.635 3.85999 20.5804 4.06385 20.6724 4.22328L22.3391 7.11003C22.4311 7.26946 22.635 7.32409 22.7944 7.23204L23.3718 6.89871C23.5312 6.80666 23.5858 6.6028 23.4938 6.44337L21.8271 3.55661C21.7351 3.39718 21.5312 3.34256 21.3718 3.43461L20.7944 3.76794ZM19.0624 4.76794C18.903 4.85999 18.8483 5.06385 18.9404 5.22328L20.6071 8.11003C20.6991 8.26946 20.903 8.32409 21.0624 8.23204L21.6397 7.89871C21.7992 7.80666 21.8538 7.6028 21.7618 7.44337L20.0951 4.55661C20.003 4.39718 19.7992 4.34256 19.6397 4.43461L19.0624 4.76794ZM4.50663 13.5566C4.41458 13.3972 4.46921 13.1933 4.62864 13.1013L5.20599 12.7679C5.36542 12.6759 5.56928 12.7305 5.66133 12.8899L7.328 15.7767C7.42004 15.9361 7.36542 16.14 7.20599 16.232L6.62864 16.5654C6.46921 16.6574 6.26534 16.6028 6.17329 16.4434L4.50663 13.5566ZM6.36069 12.1013C6.20126 12.1933 6.14663 12.3972 6.23868 12.5566L7.90535 15.4434C7.99739 15.6028 8.20126 15.6574 8.36069 15.5654L8.93804 15.232C9.09747 15.14 9.15209 14.9361 9.06005 14.7767L7.39338 11.8899C7.30133 11.7305 7.09747 11.6759 6.93804 11.7679L6.36069 12.1013ZM20.6071 11.8899C20.6991 11.7305 20.903 11.6759 21.0624 11.7679L21.6397 12.1013C21.7992 12.1933 21.8538 12.3972 21.7618 12.5566L20.0951 15.4434C20.003 15.6028 19.7992 15.6574 19.6397 15.5654L19.0624 15.232C18.903 15.14 18.8483 14.9361 18.9404 14.7767L20.6071 11.8899ZM22.7944 12.7679C22.635 12.6759 22.4311 12.7305 22.3391 12.8899L20.6724 15.7767C20.5804 15.9361 20.635 16.14 20.7944 16.232L21.3718 16.5654C21.5312 16.6574 21.7351 16.6028 21.8271 16.4434L23.4938 13.5566C23.5858 13.3972 23.5312 13.1933 23.3718 13.1013L22.7944 12.7679ZM8.36069 4.43461C8.20126 4.34256 7.99739 4.39718 7.90535 4.55661L6.23868 7.44337C6.14663 7.6028 6.20126 7.80666 6.36069 7.89871L6.93804 8.23204C7.09747 8.32409 7.30133 8.26946 7.39338 8.11003L9.06005 5.22328C9.15209 5.06385 9.09747 4.85999 8.93804 4.76794L8.36069 4.43461Z",
    fill: "#262626"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.6087980e9fd73d686c56445e30c740c3.svg";
export { ForwardRef as ReactComponent };